import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#F1F5F9] p-6 text-center">
      <XCircle className="h-16 w-16 text-slate-400" />
      <h1 className="mt-4 text-2xl font-bold text-[#263871]">Paiement annulé</h1>
      <p className="mt-2 text-slate-600">Aucun montant n'a été débité.</p>
      <Button onClick={() => navigate(-1)} className="mt-6 rounded-full bg-[#263871] px-8">Revenir</Button>
    </div>
  );
}
